export function buildSchemaMap(schemaInput, defaultServiceKey = "DEFAULT") {
  if (!schemaInput || typeof schemaInput !== "object") return {};

  const values = Object.values(schemaInput);
  const isServiceBased =
    values.length > 0 &&
    values.every((val) => typeof val === "object" && !Array.isArray(val));

  if (isServiceBased) {
    return schemaInput;
  }

  return { [defaultServiceKey]: schemaInput };
}

export function collectFields({
  schemaMap,
  service,
  schemaKey,
  defaultServiceKey = "DEFAULT",
}) {
  if (!schemaMap || !schemaKey) return [];
  const byService = service ? schemaMap[service] : undefined;
  const fallback = schemaMap[defaultServiceKey];
  const schema = byService || fallback || {};
  return schema?.[schemaKey] || [];
}
